module.exports = __webpack_public_path__ + "img/banner-sm-01.0ea204ab.jpg";